import React, { useState, useEffect } from "react";
import '../../styles/MenuItems.css';
import "../../styles/Styles.css";

function Appetizers() {

    const [appetizers, setAppetizers] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === "PRZYSTAWKI");
            if (category) {
                setAppetizers(category.menu_items);
        }
        });
    }, []);

    return (
        <div className="container-fluid">
            <div className="container section-menu-item">
                <div className="dish-photo-container">
                        <img src={require("../../assets/menu/salad.webp")} className="dish-photo-menu img-menu img-rounded shadow" />
                    </div>
                    <div className="menu-right-55">
                        <p className="menu-item-title-font fs-1 fw-bold">PRZYSTAWKI</p>
                        <hr/>
                        {appetizers.map((appetizer) => (
                        <div key={appetizer.id} className="container">
                            <div className="dish-name-container d-flex justify-content-between">
                                <p className="menu-item-title-font fs-5 m-0">{appetizer.name}</p>
                                <p className="fs-5 m-0">{appetizer.price}zł</p>
                            </div>
                        <p className="ingridients-container fs-6 m-0 fw-lighter">{appetizer.ingredients}</p>
                        <div className="mb-3 mt-3 divide-line"/>
                    </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default Appetizers;